export default __webpack_public_path__ + "static/media/user.55758720.png";